const trimToString = (value) => {
  if (typeof value === "string") return value.trim();
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const normalizeAttachment = (attachment = {}) => {
  if (!attachment || typeof attachment !== "object") return null;
  const url = trimToString(attachment.url);
  const publicId = trimToString(attachment.publicId);
  if (!url && !publicId) return null;

  return {
    url,
    publicId,
    resourceType: trimToString(attachment.resourceType) || "image",
    mimeType: trimToString(attachment.mimeType),
    sizeBytes:
      typeof attachment.sizeBytes === "number" && Number.isFinite(attachment.sizeBytes)
        ? attachment.sizeBytes
        : undefined,
  };
};

export const getBookingAnswerText = (answer) => {
  if (answer === null || answer === undefined) return "";
  if (typeof answer === "boolean") return answer ? "Yes" : "No";
  if (typeof answer === "object") {
    return trimToString(answer.text ?? answer.answer ?? answer.value);
  }
  return trimToString(answer);
};

export const getBookingAnswerAttachments = (answer) => {
  if (!answer || typeof answer !== "object") return [];
  const attachments = answer.attachments;
  if (!Array.isArray(attachments)) return [];
  return attachments.map(normalizeAttachment).filter(Boolean);
};

export const formatBookingAnswerValue = (answer) => {
  const text = getBookingAnswerText(answer);
  const attachmentCount = getBookingAnswerAttachments(answer).length;

  if (attachmentCount > 0 && text) {
    return `${text} (${attachmentCount} photo${attachmentCount === 1 ? "" : "s"} attached)`;
  }

  if (attachmentCount > 0) {
    return `${attachmentCount} photo${attachmentCount === 1 ? "" : "s"} attached`;
  }

  return text;
};
